import { render, staticRenderFns } from "./Pauta.vue?vue&type=template&id=eddfe458"
import script from "./Pauta.vue?vue&type=script&lang=js"
export * from "./Pauta.vue?vue&type=script&lang=js"
import style0 from "./Pauta.vue?vue&type=style&index=0&id=eddfe458&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports